

















import { Component, Vue } from 'vue-property-decorator'
import CardItem from '@/components/home/CardItem.vue'
import { CardList } from '@/types/Card'
import HomeModule from '@/store/home'

@Component({
  components: {
    CardItem
  }
})
export default class CardGrid extends Vue {
  private get cardlist(): CardList {
    return HomeModule.cardlist!
  }
}
